import React from 'react';
import ComingSoon from '../../../components/ComingSoon';

const Streams: React.FC = () => {
  return (
    <div className="shadow rounded-lg bg-white">
      <ComingSoon
        label={`On it's way`}
        title="Streaming"
        description={`Easily create public or private live streams and connect with your audience. We're building the platform that will give real estate the proper tools for streaming`}
      />
    </div>
  );
};

export default Streams;
